import { getDefaultLogo } from '@weareopenr/component-library';
import type { AvatarGroupProps } from '@weareopenr/component-library/build/components/AvatarGroup/AvatarGroup';

export interface IExternalSystem {
  name: string;
}

export const channelToAvatar = (channel: IExternalSystem): AvatarGroupProps['avatars'][number] => {
  const name = channel.name.split(' ').at(0)?.toLocaleLowerCase();

  if (getDefaultLogo(name).startsWith('data:image/svg+xml,%3csvg')) {
    return { initials: channel.name.slice(0, 2), variant: 'custom' as const };
  }

  return { brand: name, variant: 'custom' as const };
};

export const publishChannelsToAvatars = (channels: IExternalSystem[]): AvatarGroupProps['avatars'] =>
  channels.map(channelToAvatar);
